import { defineStore } from 'pinia';
import router from '@/router';
import { Home } from '@/router/RouterNames';
import { getUsuarioFromLocalStorage, parseJwt, removeToken, setToken } from '@/services/utils/securityUtils';
import { rolAdmin, rolComercial, ROLE_GESTOR_ROOMING, rolTicketera } from '@/constants/rolesName';
import { normalizeDateYYYYMMDD } from '@/helpers/dateUtiles';

export const useUserStore = defineStore('userStore', {
  state: () => ({
    logged: false,
    usuario: {
      id: null,
      nombre: null,
      apellidos: null,
      roles: {},
      email: null,
      fechaNacimiento: null,
    },
    error: null,
  }),

  getters: {
    isLogged: state => state.logged,
    getUsuario: state => state.usuario,
    getErrorMessage: state => {
      if (state.error && state.error.response && state.error.response.data) {
        return state.error.response.data;
      }
      return null;
    },
    hasRoleGestorRooming: state => {
      return state.usuario.roles?.includes(ROLE_GESTOR_ROOMING) || false;
    },
    hasRoleComercial: state => {
      return state.usuario.roles?.includes(rolComercial) || false;
    },
    hasRoleTicketera: state => {
      return state.usuario.roles?.includes(rolTicketera) || false;
    },
    hasRoleAdmin: state => {
      return state.usuario.roles?.includes(rolAdmin) || false;
    },
  },

  actions: {
    async obtieneInformacionUsuario() {
      const usuario = getUsuarioFromLocalStorage();
      this._guardaInformacionUsuario(usuario);
    },

    login(token) {
      setToken(token);
      const usuario = parseJwt(token);
      this._guardaInformacionUsuario(usuario);
      return usuario;
    },

    logout(redirect = false) {
      removeToken();
      // Reset state
      this.logged = false;
      this.usuario.id = null;
      this.usuario.nombre = null;
      this.usuario.apellidos = null;
      this.usuario.roles = null;
      this.usuario.email = null;
      this.usuario.fechaNacimiento = null;
      if (redirect) router.push({ name: Home });
    },

    _guardaInformacionUsuario(usuario) {
      if (usuario) {
        this.logged = true;
        this.usuario.id = usuario.id;
        this.usuario.nombre = usuario.nombre;
        this.usuario.apellidos = usuario.apellidos;
        this.usuario.roles = usuario.roles;
        this.usuario.email = usuario.username;
        this.usuario.uuid = usuario.uuid;
        this.usuario.fechaNacimiento = normalizeDateYYYYMMDD(usuario.fechaNacimiento);
      }
    },
  },
});
